import { defineTokens } from '@chakra-ui/react';

import { spacing } from './spacing';

export const tokens = defineTokens({ ...spacing });
